import { useSelector } from "react-redux";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import Error from "../ui/Error";
import Book from "./Book";

export default function Books() {
  const { data, isLoading, isError } = useGetBooksQuery();
  const {isFeatured, queryString} = useSelector(state=>state.filter)

  const filterByFeature = (book) => {
    if (isFeatured) {
      return book.featured;
    }
    return true;
  };

  const filterByQueryStr = (book) => {
    if (queryString != '') {
      const name = book.name.toLowerCase();
      return name.includes(queryString.toLowerCase());
    }
    return true;
  };

  // decide what to render
  let content = null;

  if (isLoading) {
    content = (
      <div className="flex h-full justify-center items-center">
        Loading...
      </div>
    );
  } else if (isError) {
    content = <Error message="There was an error" />;
  } else if (data?.length === 0) {
    content = <Error message="No books found!" />;
  } else if (data?.length > 0) {
    content = <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {data?.filter(filterByFeature).filter(filterByQueryStr).map((book) => <Book key={book.id} book={book} />)}
    </div>
  }

  return content;
}